

exports.__esModule = true;
exports.$CheckoutSessionModel = exports.$CheckoutPlanModel = exports.$CheckoutShippingAddressesModel = exports.$CreditOptionsModel = exports.$CheckoutPayeeModel = exports.$ShippingAddressModel = exports.$CheckoutShippingAddressModel = exports.$FlowEligibilityModel = exports.$InstallmentOptionsModel = exports.$FundingOptionsModel = exports.$FundingSourceModel = exports.$CheckoutAppDataModel = exports.$CheckoutCartModel = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _squid = require('squid');

var $CheckoutCartModel = exports.$CheckoutCartModel = _squid.$Model.extend('$CheckoutCartModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/cart',
        cache: true
    }),

    isPurchase: function isPurchase() {
        return Boolean(this.purchase);
    },

    isBilling: function isBilling() {
        return Boolean(this.billing);
    },

    isBillingPurchase: function isBillingPurchase() {
        return this.isPurchase() && this.isBilling();
    },

    isBillingNoPurchase: function isBillingNoPurchase() {
        return this.isBilling() && !this.isPurchase();
    },

    getBillingDescription: function getBillingDescription() {
        return this.billing && this.billing.description;
    },

    isMultiSellerPurchase: function isMultiSellerPurchase() {
        return this.purchaseUnits && this.purchaseUnits.length > 1;
    },

    isShippingMethodStorePickUp: function isShippingMethodStorePickUp() {
        return this.purchase && (this.purchase.shipping_method === '29' || this.purchase.shipping_method === '21');
    },

    isWalletTokenization: function isWalletTokenization() {
        return this.billing && this.billing.intent === 'TOKENIZED_WALLET';
    },
    getExternalCallbackOptions: function getExternalCallbackOptions() {
        return this.purchaseUnits && this.purchaseUnits[0] && this.purchaseUnits[0].external_callback_options;
    }
});

var $CheckoutAppDataModel = exports.$CheckoutAppDataModel = _squid.$Model.extend('$CheckoutAppDataModel', {

    api: new _squid.$Api({
        uri: '/api/checkout/:id/appData'
    }),

    useraction: function useraction() {
        // user_action from session takes precedence over CGI param.
        var incontext_integration = window.xchild && window.xchild.props.commit ? 'commit' : false;
        var rest_integration = this.flags && this.flags.user_action === 'PAY' ? 'commit' : false;

        return rest_integration || incontext_integration || _squid.$util.param('useraction');
    },

    doec_on_approve: function doec_on_approve() {
        return this.flags && this.flags.doec_on_approve;
    }
});

var $FundingSourceModel = exports.$FundingSourceModel = _squid.$Model.extend('$FundingSourceModel', {

    formatLast4: function formatLast4() {
        var last4;

        if (this.last4) {
            last4 = this.last4;

            if (!this.parent.isAuthRequired) {
                last4 = 'x-' + last4;
            }
        }

        return last4;
    }
});

var $FundingOptionsModel = exports.$FundingOptionsModel = _squid.$Model.extend('$FundingOptionsModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/fundingOptions',
        postAttempts: 2
    }),

    eachPlan: function eachPlan(method, context) {
        angular.forEach(this.plans, method, this);
    },

    hasECheck: function hasECheck() {
        return _squid.$util.some(this.instruments, function (instrument) {
            return instrument.type === 'ECHECK' || instrument.subtype === 'ECHECK';
        });
    },

    hasCredit: function hasCredit() {
        return _squid.$util.some(this.instruments, function (instrument) {
            return instrument.type === 'CREDIT';
        });
    },

    getBankPlanIdByInstrumentId: function getBankPlanIdByInstrumentId(id, subType) {
        var fundingInstrument = _squid.$util.find(this.plans, function (plan) {
            return plan.primaryFs && plan.primaryFs.type === 'BANK' && plan.primaryFs.id === id && plan.primaryFs.subtype === subType;
        });

        return fundingInstrument && fundingInstrument.planId;
    },

    onPopulate: function onPopulate() {
        var self = this;
        angular.forEach(this.plans, function (plan) {
            if (plan.primaryFs && plan.primaryFs.type === 'BANK' && (plan.primaryFs.subtype === 'IACH' || plan.primaryFs.subtype === 'PAD')) {
                Object.defineProperty(plan.primaryFs, plan.primaryFs.subtype === 'IACH' ? 'padPlanId' : 'iachPlanId', {
                    enumerable: true,
                    configurable: false,
                    writeable: false,
                    value: self.getBankPlanIdByInstrumentId(plan.primaryFs.id, plan.primaryFs.subtype === 'IACH' ? 'PAD' : 'IACH')
                });
            }
        });
    },

    getBankPadPlanIdByInstrumentId: function getBankPadPlanIdByInstrumentId(id, subtype) {
        var bankPadPlan = this.plans.find(function (plan) {
            return plan.primaryFs && plan.primaryFs.id === id && plan.primaryFs.type === 'BANK' && plan.primaryFs.subtype === subtype;
        });

        return bankPadPlan.primaryFs && (bankPadPlan.primaryFs.subtype === 'IACH' ? bankPadPlan.primaryFs.padPlanId : bankPadPlan.primaryFs.iachPlanId);
    },

    isPadToggleApplicable: function isPadToggleApplicable() {
        var padToggleApplicable = false;
        this.eachPlan(function (plan) {
            if (!padToggleApplicable && plan.primaryFs && plan.primaryFs.type === 'BANK') {
                if (plan.primaryFs.subtype === 'IACH' && plan.primaryFs.hasOwnProperty('padPlanId')) {
                    padToggleApplicable = plan.primaryFs.padPlanId ? true : false;
                } else if (plan.primaryFs.subtype === 'PAD' && plan.primaryFs.hasOwnProperty('iachPlanId')) {
                    padToggleApplicable = plan.primaryFs.iachPlanId ? true : false;
                }
            }
        }, this);

        return padToggleApplicable;
    },

    isPadToggleApplicableForFS: function isPadToggleApplicableForFS(planId) {
        var padToggleApplicable = false;
        var selectedPlan = _squid.$util.find(this.plans, function (plan) {
            return plan.planId === planId;
        });

        if (selectedPlan.primaryFs && selectedPlan.primaryFs.type === 'BANK' && (selectedPlan.primaryFs.subtype === 'IACH' && selectedPlan.primaryFs.padPlanId || selectedPlan.primaryFs.subtype === 'PAD' && selectedPlan.primaryFs.iachPlanId)) {
            padToggleApplicable = true;
        }

        return padToggleApplicable;
    },

    getPreferred: function getPreferred() {
        return _squid.$util.find(this.plans, function (plan) {
            return plan.primaryFs.isPreferred;
        });
    }
});

var $InstallmentOptionsModel = exports.$InstallmentOptionsModel = _squid.$Model.extend('$InstallmentOptionsModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/installmentOptions/',
        postAttempts: 2
    })
});

var $FlowEligibilityModel = exports.$FlowEligibilityModel = _squid.$Model.extend('$FlowEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/flowEligibility'
    })
});

var $CheckoutShippingAddressModel = exports.$CheckoutShippingAddressModel = _squid.$Model.extend('$CheckoutShippingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:parent.id/shipping/:id'
    })
});

var $ShippingAddressModel = exports.$ShippingAddressModel = _squid.$Model.extend('$ShippingAddressModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/shipping/add'
    }),

    serialize: function serialize() {
        return {
            first_name: this.first_name,
            last_name: this.last_name,
            recipient_name: this.recipient_name,
            line1: this.line1,
            line2: this.line2,
            city: this.city,
            state: this.state,
            postal_code: this.postal_code,
            country: this.country
        };
    }
});

var $CheckoutPayeeModel = exports.$CheckoutPayeeModel = _squid.$Model.extend('$CheckoutPayeeModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/payee'
    }),

    getId: function getId() {
        return this.merchant && this.merchant.id;
    },

    isGambling: function isGambling() {
        return this.merchant && this.merchant.isGambling;
    }
});

var $CreditOptionsModel = exports.$CreditOptionsModel = {
    sacEligibleAmount: {
        US: 99,
        GB: 150
    }
};

var $CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressesModel = _squid.$Model.extend('$CheckoutShippingAddressesModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/:id/shipping'
    }),

    onPopulate: function onPopulate() {
        this.addresses = this.children($CheckoutShippingAddressModel, this.addresses);
    },

    getPreferredShippingAddress: function getPreferredShippingAddress() {
        var preferredAddress = {};

        if (this.addresses) {
            var i = void 0;
            var address = void 0;

            for (i = 0; i < this.addresses.length; i++) {
                address = this.addresses[i];

                if (address && address.preferred_address) {
                    preferredAddress = {
                        'line1': address.line1,
                        'line2': address.line2,
                        'city': address.city,
                        'state': address.state,
                        'postal_code': address.postal_code,
                        'country_code': address.country_code
                    };

                    break;
                }
            }
        }
        return preferredAddress;
    },

    getPrimaryShippingAddress: function getPrimaryShippingAddress() {
        var primaryAddress = {};

        if (this.addresses) {
            var i = void 0;
            var address = void 0;

            for (i = 0; i < this.addresses.length; i++) {
                address = this.addresses[i];

                if (address && address.primary_address) {
                    primaryAddress = {
                        'line1': address.line1,
                        'line2': address.line2,
                        'city': address.city,
                        'state': address.state,
                        'postal_code': address.postal_code,
                        'country_code': address.country_code
                    };

                    break;
                }
            }
        }
        return primaryAddress;
    }
});

var $CheckoutPlanModel = exports.$CheckoutPlanModel = _squid.$Model.extend('$CheckoutPlanModel', {

    onPopulate: function onPopulate() {
        this.sources = this.children($FundingSourceModel, this.sources);
    },

    eachSource: function eachSource(method, context) {
        angular.forEach(this.sources, method, this);
    },

    hasFundingMethodType: function hasFundingMethodType(name) {
        var found = false;

        this.eachSource(function (source) {
            if (source.type === name) {
                found = true;
            }
        }, this);

        return found;
    },

    hasFundingMethodSubType: function hasFundingMethodSubType(name) {
        var found = false;

        this.eachSource(function (source) {
            if (source.sub_type === name) {
                found = true;
            }
        }, this);

        return found;
    },

    isPAD: function isPAD() {
        return this.hasFundingMethodSubType('DELAYED_TRANSFER');
    },

    isIACH: function isIACH() {
        var found = false;

        this.eachSource(function (source) {
            if (source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER') {
                found = true;
            }
        }, this);

        return found;
    },

    isSplitPaymentWithBalanceAndIach: function isSplitPaymentWithBalanceAndIach() {
        return this.sources && this.sources.length > 1 && this.hasFundingMethodType('BALANCE') && this.isIACH();
    },

    isMSB: function isMSB() {
        return this.sources && this.sources.length === 1 && this.sources[0].type === 'INCENTIVE';
    },

    isBalance: function isBalance() {
        return this.sources && this.sources.length === 1 && this.sources[0].type === 'BALANCE';
    },

    hasConversion: function hasConversion() {
        return this.conversion !== null && _typeof(this.conversion) === 'object';
    }
});

var $CheckoutSessionModel = exports.$CheckoutSessionModel = _squid.$Model.extend('$CheckoutSessionModel', {

    api: new _squid.$Api({
        uri: '/api/checkout/:id/session',
        postAttempts: 2
    }),

    onPopulate: function onPopulate() {
        this.plan = new $CheckoutPlanModel(this.plan);
        this.shipping = this.child($CheckoutShippingAddressModel, this.shipping);
        this.fundingOptions = this.child($FundingOptionsModel, this.fundingOptions);
    },

    getSelectedStickyInstrument: function getSelectedStickyInstrument() {

        if (this.selectedFuturePaymentInstrument) {
            return this.selectedFuturePaymentInstrument;
        }

        if (!this.futurePaymentInstruments) {
            return;
        }

        if (!(this.plan && this.plan.sources) && this.futurePaymentInstruments) {
            return this.futurePaymentInstruments[0];
        }

        var selectedInstrumentId = _squid.$util.some(this.plan.sources, function (fi) {
            return fi.instrument_id ? fi.instrument_id : undefined;
        });

        var stickyInstrument = _squid.$util.find(this.futurePaymentInstruments, function (fi) {
            return fi.instrument_id === selectedInstrumentId;
        });

        return stickyInstrument;
    },

    getPlanList: function getPlanList() {
        return this.fundingOptions && this.fundingOptions.plans;
    },

    // returns true if more than one plan uses BALANCE as the primary FI
    isMultipleBalancePlan: function isMultipleBalancePlan() {
        var matchingBalancePlans = 0;

        return this.fundingOptions && this.fundingOptions.plans && this.fundingOptions.plans.some(function (plan) {
            // if BALANCE is the primary FI...
            if (plan.primaryFs.name === 'BALANCE') {
                // increment number of balance plans found
                matchingBalancePlans++;
            }
            // exit once we have more than one balance plan
            return matchingBalancePlans > 1;
        });
    },

    getDisallowedInstruments: function getDisallowedInstruments() {
        return this.fundingOptions && this.fundingOptions.disallowedInstruments;
    },

    getDisallowedPreferred: function getDisallowedPreferred() {
        var disallowedInstrument = this.getDisallowedInstruments();

        // find only the disallowed instrument that has been marked as preferred.
        disallowedInstrument = disallowedInstrument && _squid.$util.find(disallowedInstrument, function (fi) {
            return fi.isPreferred;
        });

        // if the disallowed instrument is in the plan list (in the case that the instrument has a BUF)
        // we do not show it in the disallowed section.
        var isDisallowedInstrumentInPlanList = disallowedInstrument && _squid.$util.some(this.getPlanList(), function (plan) {
            var instrumentID = plan.primaryFs && plan.primaryFs.id;
            if (instrumentID && disallowedInstrument.id) {
                return instrumentID === disallowedInstrument.id;
            } else {
                return false;
            }
        });

        return !isDisallowedInstrumentInPlanList && disallowedInstrument;
    },

    getShippingAddressMinimalDetails: function getShippingAddressMinimalDetails() {
        return {
            'line1': this.shipping.line1,
            'line2': this.shipping.line2,
            'city': this.shipping.city,
            'state': this.shipping.state,
            'postal_code': this.shipping.postal_code,
            'country_code': this.shipping.country
        };
    }
});

angular.value("$CheckoutCartModel", $CheckoutCartModel);
angular.value("$CheckoutAppDataModel", $CheckoutAppDataModel);
angular.value("$FundingSourceModel", $FundingSourceModel);
angular.value("$FundingOptionsModel", $FundingOptionsModel);
angular.value("$InstallmentOptionsModel", $InstallmentOptionsModel);
angular.value("$FlowEligibilityModel", $FlowEligibilityModel);
angular.value("$CheckoutShippingAddressModel", $CheckoutShippingAddressModel);
angular.value("$ShippingAddressModel", $ShippingAddressModel);
angular.value("$CheckoutPayeeModel", $CheckoutPayeeModel);
angular.value("$CreditOptionsModel", $CreditOptionsModel);
angular.value("$CheckoutShippingAddressesModel", $CheckoutShippingAddressesModel);
angular.value("$CheckoutPlanModel", $CheckoutPlanModel);
angular.value("$CheckoutSessionModel", $CheckoutSessionModel);
_squid.$Model;

_squid.$Api;

_squid.$util;


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/checkout/index.js
// module id = ./components/xo-models/src/checkout/index.js
// module chunks = 1